module.exports = __webpack_public_path__ + "img/DNARepair-SCC_GSE144240.6823d517.png";